import { Icon } from '@iconify/react';
import RevealWrap from './RevealWrap';
import CountUp from './CountUp';

const STATS = [
  { icon: 'solar:graph-up-bold', iconColor: 'text-brand-600', bg: 'bg-brand-100', val: 300, prefix: '최대 ', suffix: '%', label: '매출 상승', desc: '네이버 리뷰 유입으로 신규 손님 폭발적 증가', barWidth: '95%', barColor: 'bg-brand-400' },
  { icon: 'solar:hand-money-bold', iconColor: 'text-emerald-600', bg: 'bg-emerald-100', val: 82, prefix: '', suffix: '%', label: '인건비 절감', desc: '주문 접수 인력 최소화', barWidth: '90%', barColor: 'bg-emerald-400' },
  { icon: 'solar:clock-circle-bold', iconColor: 'text-blue-600', bg: 'bg-blue-100', val: 95, prefix: '', suffix: '%', label: '주문 시간 단축', desc: 'QR 스캔 3초만에 주문 시작', barWidth: '97%', barColor: 'bg-blue-400' },
  { icon: 'solar:refresh-circle-bold', iconColor: 'text-violet-600', bg: 'bg-violet-100', val: 156, prefix: '', suffix: '%', label: '테이블 회전율', desc: '빠른 주문으로 회전율 극대화', barWidth: '92%', barColor: 'bg-violet-400' },
];

export default function Results() {
  return (
    <section id="results" className="py-28 lg:py-40 bg-neutral-50 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-100/50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 opacity-60 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-blue-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4 opacity-40 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16 items-start">
          <RevealWrap animation="left" className="lg:col-span-2 lg:sticky lg:top-32">
            <p className="text-brand-600 font-semibold text-sm tracking-wide uppercase mb-3">Before &amp; After</p>
            <h2 className="text-3xl lg:text-5xl font-bold leading-tight tracking-tight text-neutral-900 mb-4">
              도입 전후,<br />숫자가 다릅니다
            </h2>
            <p className="text-neutral-500 text-lg leading-relaxed mb-6">
              와우오더를 도입한 매장의 평균 운영 지표 변화입니다.
            </p>
            <div className="bg-red-50 border border-red-200/60 rounded-xl px-5 py-3 inline-block">
              <p className="text-red-600 text-sm font-semibold">QR오더 없이 매달 잃고 있는 매출, 얼마인지 아시나요?</p>
            </div>
          </RevealWrap>

          <div className="lg:col-span-3 grid sm:grid-cols-2 gap-5">
            {STATS.map((s, i) => (
              <RevealWrap key={s.label} animation="scale" className={i > 0 ? `reveal-delay-${i}` : ''}>
                <div className="group p-7 rounded-3xl bg-white border border-neutral-200/80 bento-item h-full relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-transparent to-neutral-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="relative z-10">
                    <div className={`w-12 h-12 rounded-2xl ${s.bg} flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-500`}>
                      <Icon icon={s.icon} className={`${s.iconColor} text-xl`} />
                    </div>
                    <p className="text-4xl lg:text-5xl font-bold text-neutral-900 mb-2">
                      <CountUp end={s.val} prefix={s.prefix} suffix={s.suffix} />
                    </p>
                    <p className="text-lg font-semibold text-neutral-700 mb-1">{s.label}</p>
                    <p className="text-neutral-500 text-sm mb-4">{s.desc}</p>
                    <div className="h-1.5 bg-neutral-100 rounded-full overflow-hidden">
                      <div
                        className={`progress-bar h-full ${s.barColor} rounded-full`}
                        style={{ '--progress': s.barWidth }}
                      />
                    </div>
                  </div>
                </div>
              </RevealWrap>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
